var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/action-button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { followAccount, unfollowAccount, blockAccount, unblockAccount, muteAccount, unmuteAccount, authorizeFollowRequest, rejectFollowRequest } from 'soapbox/actions/accounts';
import { openModal } from 'soapbox/actions/modals';
import { Button, HStack } from 'soapbox/components/ui';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
const messages = defineMessages({
  block: {
    "id": "account.block",
    "defaultMessage": "Block @{name}"
  },
  blocked: {
    "id": "account.blocked",
    "defaultMessage": "Blocked"
  },
  edit_profile: {
    "id": "account.edit_profile",
    "defaultMessage": "Edit profile"
  },
  follow: {
    "id": "account.follow",
    "defaultMessage": "Follow"
  },
  mute: {
    "id": "account.mute",
    "defaultMessage": "Mute @{name}"
  },
  remote_follow: {
    "id": "account.remote_follow",
    "defaultMessage": "Remote follow"
  },
  requested: {
    "id": "account.requested",
    "defaultMessage": "Awaiting approval. Click to cancel follow request"
  },
  requested_small: {
    "id": "account.requested_small",
    "defaultMessage": "Awaiting approval"
  },
  unblock: {
    "id": "account.unblock",
    "defaultMessage": "Unblock @{name}"
  },
  unfollow: {
    "id": "account.unfollow",
    "defaultMessage": "Unfollow"
  },
  unmute: {
    "id": "account.unmute",
    "defaultMessage": "Unmute @{name}"
  },
  authorize: {
    "id": "follow_request.authorize",
    "defaultMessage": "Authorize"
  },
  reject: {
    "id": "follow_request.reject",
    "defaultMessage": "Reject"
  }
});

/**
 * Circumstantial action button (usually "Follow") to display on accounts.
 * May say "Unblock" or something else, depending on the relationship and
 * `actionType` prop.
 */
const ActionButton = _ref => {
  let {
    account,
    actionType,
    small
  } = _ref;
  const dispatch = useDispatch();
  const features = useFeatures();
  const intl = useIntl();
  const me = useAppSelector(state => state.me);

  const handleFollow = () => {
    var _account$relationship, _account$relationship2;

    if ((_account$relationship = account.relationship) !== null && _account$relationship !== void 0 && _account$relationship.following || (_account$relationship2 = account.relationship) !== null && _account$relationship2 !== void 0 && _account$relationship2.requested) {
      dispatch(unfollowAccount(account.id));
    } else {
      dispatch(followAccount(account.id));
    }
  };

  const handleBlock = () => {
    var _account$relationship3;

    if ((_account$relationship3 = account.relationship) !== null && _account$relationship3 !== void 0 && _account$relationship3.blocking) {
      dispatch(unblockAccount(account.id));
    } else {
      dispatch(blockAccount(account.id));
    }
  };

  const handleMute = () => {
    var _account$relationship4;

    if ((_account$relationship4 = account.relationship) !== null && _account$relationship4 !== void 0 && _account$relationship4.muting) {
      dispatch(unmuteAccount(account.id));
    } else {
      dispatch(muteAccount(account.id));
    }
  };

  const handleAuthorize = () => {
    dispatch(authorizeFollowRequest(account.id));
  };

  const handleReject = () => {
    dispatch(rejectFollowRequest(account.id));
  };

  const handleRemoteFollow = () => {
    dispatch(openModal('UNAUTHORIZED', {
      action: 'FOLLOW',
      account: account.id,
      ap_id: account.url
    }));
  };
  /** Handles actionType='muting' */


  const mutingAction = () => {
    var _account$relationship5;

    const isMuted = (_account$relationship5 = account.relationship) === null || _account$relationship5 === void 0 ? void 0 : _account$relationship5.muting;
    const messageKey = isMuted ? messages.unmute : messages.mute;
    const text = intl.formatMessage(messageKey, {
      name: account.username
    });
    return /*#__PURE__*/React.createElement(Button, {
      theme: isMuted ? 'danger' : 'secondary',
      size: "sm",
      text: text,
      onClick: handleMute,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 7
      }
    });
  };
  /** Handles actionType='blocking' */


  const blockingAction = () => {
    var _account$relationship6;

    const isBlocked = (_account$relationship6 = account.relationship) === null || _account$relationship6 === void 0 ? void 0 : _account$relationship6.blocking;
    const messageKey = isBlocked ? messages.unblock : messages.block;
    const text = intl.formatMessage(messageKey, {
      name: account.username
    });
    return /*#__PURE__*/React.createElement(Button, {
      theme: isBlocked ? 'danger' : 'secondary',
      size: "sm",
      text: text,
      onClick: handleBlock,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 7
      }
    });
  };

  const followRequestAction = () => {
    var _account$relationship7;

    if ((_account$relationship7 = account.relationship) !== null && _account$relationship7 !== void 0 && _account$relationship7.followed_by) return null;
    return /*#__PURE__*/React.createElement(HStack, {
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 134,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Button, {
      theme: "secondary",
      size: "sm",
      text: intl.formatMessage(messages.authorize),
      onClick: handleAuthorize,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement(Button, {
      theme: "danger",
      size: "sm",
      text: intl.formatMessage(messages.reject),
      onClick: handleReject,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 141,
        columnNumber: 9
      }
    }));
  };
  /** Render a remote follow button, depending on features. */


  const renderRemoteFollow = () => {
    // Remote follow through the API.
    if (features.remoteInteractions) {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: handleRemoteFollow,
        icon: require('@tabler/icons/plus.svg'),
        text: intl.formatMessage(messages.follow),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 9
        }
      }); // Pleroma's classic remote follow form.
    } else if (features.pleromaRemoteFollow) {
      return /*#__PURE__*/React.createElement("form", {
        method: "POST",
        action: "/main/ostatus",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "nickname",
        value: account.acct,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 166,
          columnNumber: 11
        }
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "profile",
        value: "",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167,
          columnNumber: 11
        }
      }), /*#__PURE__*/React.createElement(Button, {
        text: intl.formatMessage(messages.remote_follow),
        type: "submit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 168,
          columnNumber: 11
        }
      }));
    }

    return null;
  };
  /** Render remote follow if federating, otherwise hide the button. */


  const renderLoggedOut = () => {
    if (features.federating) {
      return renderRemoteFollow();
    }

    return null;
  };

  if (!me) {
    return renderLoggedOut();
  }

  if (me !== account.id) {
    var _account$relationship8, _account$relationship9, _account$relationship10, _account$relationship11, _account$relationship12, _account$relationship13;

    const isFollowing = (_account$relationship8 = account.relationship) === null || _account$relationship8 === void 0 ? void 0 : _account$relationship8.following;
    const blockedBy = (_account$relationship9 = account.relationship) === null || _account$relationship9 === void 0 ? void 0 : _account$relationship9.blocked_by;

    if (actionType) {
      if (actionType === 'muting') {
        return mutingAction();
      } else if (actionType === 'blocking') {
        return blockingAction();
      } else if (actionType === 'follow_request') {
        return followRequestAction();
      }
    }

    if (!account.relationship) {
      // Wait until the relationship is loaded
      return null;
    } else if ((_account$relationship10 = account.relationship) !== null && _account$relationship10 !== void 0 && _account$relationship10.requested) {
      // Awaiting acceptance
      return /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        theme: "tertiary",
        text: small ? intl.formatMessage(messages.requested_small) : intl.formatMessage(messages.requested),
        onClick: handleFollow,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 209,
          columnNumber: 9
        }
      });
    } else if (!((_account$relationship11 = account.relationship) !== null && _account$relationship11 !== void 0 && _account$relationship11.blocking) && !((_account$relationship12 = account.relationship) !== null && _account$relationship12 !== void 0 && _account$relationship12.muting)) {
      // Follow & Unfollow
      return /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        disabled: blockedBy,
        theme: isFollowing ? 'secondary' : 'primary',
        icon: blockedBy ? require('@tabler/icons/ban.svg') : !isFollowing && require('@tabler/icons/plus.svg'),
        onClick: handleFollow,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 219,
          columnNumber: 9
        }
      }, isFollowing ? intl.formatMessage(messages.unfollow) : intl.formatMessage(blockedBy ? messages.blocked : messages.follow));
    } else if ((_account$relationship13 = account.relationship) !== null && _account$relationship13 !== void 0 && _account$relationship13.blocking) {
      // Unblock
      return /*#__PURE__*/React.createElement(Button, {
        theme: "danger",
        size: "sm",
        text: intl.formatMessage(messages.unblock, {
          name: account.username
        }),
        onClick: handleBlock,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 236,
          columnNumber: 9
        }
      });
    }
  } else {
    // Edit profile
    return /*#__PURE__*/React.createElement(Button, {
      theme: "tertiary",
      size: "sm",
      text: intl.formatMessage(messages.edit_profile),
      to: "/settings/profile",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 247,
        columnNumber: 7
      }
    });
  }

  return null;
};

export default ActionButton;